import type { ComponentProps, ReactElement } from 'react';
import { Loader2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface AuthButtonProps extends ComponentProps<typeof Button> {
  isLoading?: boolean;
}

function AuthButton({
  isLoading = false,
  disabled,
  className,
  children,
  ...props
}: AuthButtonProps): ReactElement {
  return (
    <Button
      className={cn(
        'vtwo:h-10 vtwo:w-full vtwo:rounded vtwo:bg-auth-primary vtwo:p-2.5 vtwo:text-sm vtwo:font-semibold vtwo:text-white vtwo:shadow-none vtwo:hover:bg-auth-primary/90 vtwo:focus-visible:ring-auth-focus',
        className
      )}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading && <Loader2 aria-hidden className="vtwo:animate-spin" />}
      {children}
    </Button>
  );
}

export default AuthButton;
